import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { useLoad } from "@redotech/react-util/load";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { Context, createContext, memo, ReactNode, useContext } from "react";

export const RedoHasRivoIntegrationContext: Context<boolean | undefined> =
  createContext<boolean | undefined>(undefined);
RedoHasRivoIntegrationContext.displayName = "RedoHasRivoIntegrationContext";

export const RivoIntegrationProvider = memo(function RivoIntegrationProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const rpcClient = useContext(RedoMerchantRpcClientContext);

  const hasPermissionToViewOrderManagementPage = useHasPermission(
    ReturnsAndClaimsPermissions.VIEW_RETURN,
  );

  const hasRivoIntegration = useLoad(async () => {
    if (!rpcClient || !hasPermissionToViewOrderManagementPage) {
      return false;
    }
    const integration = await rpcClient.getRivoIntegration({});
    return !!integration;
  }, [rpcClient]);

  return (
    <RedoHasRivoIntegrationContext.Provider value={hasRivoIntegration.value}>
      {children}
    </RedoHasRivoIntegrationContext.Provider>
  );
});
